<template>
<div id="">

    <v-row>
        <v-col cols="auto">
            <v-menu  :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y transition="scale-transition" v-model="dateMenu">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="rounded-0" outlined prepend-inner-icon="mdi-calendar-blank-outline"
                                  readonly v-bind="attrs" v-model="dateFormat" v-on="on"/>
                </template>
                <v-date-picker @input="dateMenu = false" v-model="selectedDate"/>
            </v-menu>
        </v-col>
        <v-col cols="3">
            <v-autocomplete outlined :items="products" :search-input.sync="searchProduct" clearable
                            v-model="selectedProductId" item-text="name" item-value="id" placeholder="Select Product"
                            :loading="$apollo.queries.products.loading" no-filter>
                <template v-slot:item="{item}">
                    <v-list-item-avatar><img :src="imgWpx(item.Attachments[0].path, 200)" v-if="item.Attachments.length"></v-list-item-avatar>
                    <v-list-item-content><v-list-item-title v-html="item.name"/></v-list-item-content>
                </template>
            </v-autocomplete>
        </v-col><v-spacer/>
        <v-btn large class="primary text-capitalize elevation-0 mt-2 mr-2" @click="formDialog=true">Add Purchase Request</v-btn>
        <v-menu nudge-bottom="25">
            <template v-slot:activator="{ on:menu }">
                <v-btn v-on="{...menu}" large class="primary text-capitalize mr-2 mt-2">Export</v-btn>
            </template>
            <v-list>
                <v-list-item @click="exportByPriceDialog=true"><v-list-item-title>By Price Comparison</v-list-item-title></v-list-item>
                <v-list-item @click="exportByOrderDateDialog=true"><v-list-item-title>By Ordered Date</v-list-item-title></v-list-item>
                <v-list-item @click="exportByExpectedDateDialog=true"><v-list-item-title>By Expected Delivery Date</v-list-item-title></v-list-item>
                <v-list-item @click="exportByVendorDialog=true"><v-list-item-title>By Vendor</v-list-item-title></v-list-item>
            </v-list>
        </v-menu>
    </v-row>
    <v-data-table :headers="headers" :items="prProducts" :server-items-length="prProductCount" class="p-r-table"
                  @click:row="openMultiRequestPerProduct" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :footer-props="{itemsPerPageOptions:rowsPerPageItems}" fixed-header height="calc(100vh - 314px)"
                  :options.sync="options" @update:options="onUpdateOptions" :loading="loading" @update:page="$vuetify.goTo(0)">
        <template v-slot:no-data>No Products Available</template>
        <template v-slot:no-results>No Products Available</template>
        <template v-slot:item.name="{ item }">
            <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(item.Attachments)" title="View Image">
                <v-img v-if="item.Attachments.length" :src="imgWpx(item.Attachments[0].path, 200)" alt="image">
                    <template v-slot:placeholder>
                        <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                    </template>
                </v-img>
            </v-avatar>
            <span class="ellipsis product-name">
                            <span :title="item.name">{{ item.name}}</span><br>
                            <span :title="item.sku" class="f-12 grey--text text--darken-1">{{item.sku}}</span>
            </span>
        </template>
        <template v-slot:item.minRate="{ item }">{{ item.aggregate.minRate | currencyFilter}}</template>
       <!-- <template v-slot:item.orderedDate="{ item }">{{ moment(item.aggregate.orderedDate).format('DD MMM YYYY')}}</template> -->
    </v-data-table>

    <PurchaseRequestForm :dialog.sync="formDialog" :id.sync="purchaseRequestId"/>
    <RequestsPerProduct :dialog.sync="rppDialog" :productId.sync="rppProductId" :orderedDate.sync="rppOrderedDate"/>
    <ExportByPrice :dialog.sync="exportByPriceDialog"/>
    <ExportByOrderDate :dialog.sync="exportByOrderDateDialog"/>
    <ExportByExpectedDate :dialog.sync="exportByExpectedDateDialog"/>
    <ExportByVendor :dialog.sync="exportByVendorDialog"/>
    <gallery id="gallery-p-r-list" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import PurchaseRequestForm from "./PurchaseRequestForm";
import searchProduct from '../../../mixins/searchProduct';
import gallery from '../../../mixins/gallery';
import moment from 'moment';
import {SUBSCRIBE_PURCHASE_REQUEST_PRODUCTS, SUBSCRIBE_PURCHASE_REQUEST_PRODUCTS_COUNT} from "../../../graphql/subscriptions/Products";
import {
    purchase_request_products_aggregate,
    purchase_request_products_statement
} from "../../../graphql/customStatement";
import RequestsPerProduct from "./RequestsPerProduct";
import ExportByPrice from "./ExportRequests/ExportByPrice";
import ExportByOrderDate from "./ExportRequests/ExportByOrderDate";
import ExportByExpectedDate from "./ExportRequests/ExportByExpectedDate";
import ExportByVendor from "./ExportRequests/ExportByVendor";
let options= {page: 1, itemsPerPage: 25, offset:0, limit:25};
export default {
    name: "PurchaseRequest",
    components: {
        ExportByVendor,
        ExportByExpectedDate, ExportByOrderDate, ExportByPrice, RequestsPerProduct, PurchaseRequestForm},
    mixins: [searchProduct, gallery],
    apollo:{
      $subscribe:{
          prProductCount: {
              query: SUBSCRIBE_PURCHASE_REQUEST_PRODUCTS_COUNT,
              variables() {return {
                  statement: purchase_request_products_statement(this.selectedDate, this.prepareWhereString(this.selectedProductId)),
                  aggregate: 'p.aggregate',
              }},
              result({data}) { this.prProductCount = data.prProductCount.aggregate.count }
          },
        prProducts: {
              query: SUBSCRIBE_PURCHASE_REQUEST_PRODUCTS,
              variables() { return {
                  statement: purchase_request_products_statement(this.selectedDate, this.prepareWhereString(this.selectedProductId), this.prepareSortString(this.sortBy, this.sortDesc)),
                  aggregate: purchase_request_products_aggregate,
                  offset: this.options.offset, limit: this.options.limit,
              }},
              result({data}) { this.prProducts = data.prProducts; this.loading = false; }
          },
      }
    },
    data(){
        return{
            moment,
            formDialog: false,
            purchaseRequestId: null,
            prProducts: [], prProductCount: 0,
            loading: true,
            options: options, rowsPerPageItems: [25, 50, 100, -1],
            sortBy: ['recentDate'], sortDesc: [true],
            dateMenu: false,
            selectedDate: moment().format('YYYY-MM-DD'),
            selectedProductId: '',
            headers: [
                { text: 'PRODUCT NAME', value: 'name', width:370 },
                { text: 'TOTAL REQUEST', value: 'aggregate.totalRequest', align:'end' },
                { text: 'PENDING REQUEST', value: 'aggregate.pendingRequest', align:'end' },
                { text: 'CONFIRMED REQUEST', value: 'aggregate.confirmedRequest', align:'end' },
                { text: 'BEST RATE', value: 'minRate', align:'end' },
               /* { text: 'ORDERED DATE', value: 'orderedDate', align:'end', sortable:false },
                { text: 'ACTION', value: 'action', align:'end' }, */
            ],
            rppDialog: false,       /* rpp - requestsPerProduct */
            rppProductId: null,
            rppOrderedDate: null,
            exportByPriceDialog: false,
            exportByOrderDateDialog: false,
            exportByExpectedDateDialog: false,
            exportByVendorDialog: false,
        }
    },
    computed:{
        dateFormat: {
            get () { return moment(this.selectedDate).format('DD-MM-YYYY') },
            set () { this.selectedDate = null }
        }
    },
    methods:{
        openMultiRequestPerProduct(row){
            this.rppProductId = row.id;
            this.rppOrderedDate = row.aggregate.orderedDate;
            this.rppDialog = true;
        },
        prepareSortString([sortBy], [order]){
            order = order?'desc':'asc';
            if(['name'].includes(sortBy)) return `order by p."${sortBy}" ${order}`;
            if(['minRate', 'recentDate'].includes(sortBy)) return `order by ${sortBy}  ${order}`;
            if(['aggregate.totalRequest','aggregate.pendingRequest','aggregate.confirmedRequest'].includes(sortBy)) return `order by ${sortBy.split('.')[1]}  ${order}`;
            return ''
        },
        prepareWhereString(productId){
            if(productId) return `where p."id" = '${productId}'`;
            return '';
        },
        onUpdateOptions(val){
            if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                this.options.limit = this.prProductCount          //assign total count
                this.options.offset = 0
            }else{
                this.options.limit = val.itemsPerPage
                this.options.offset = (val.page -1) * val.itemsPerPage;
            }
        },
    }
}
</script>

<style scoped>
/deep/ .vue-daterange-picker .dropdown-menu {
    top: 40px;
}

/deep/ .reportrange-text {
    /*width: 212px;*/
    text-align: center;
    padding: 14px 10px;
    border: 1px solid rgba(0, 0, 0, .14);
    margin: 0 0 0 6px;
}
.p-r-table:hover {
    cursor: pointer;
}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*cursor: default;*/
}
.product-name {
    display: inline-block;
    vertical-align: middle;
    width: 250px;
    max-width: 250px;
}
</style>